import classNames from 'classnames';
import {ComponentProps, FC, ReactNode} from 'react';

import {Icon} from 'components/Icon/Icon';
import {Text} from 'components/Text/Text';

import styles from './PaymentOption.module.css';

type Props = {
    className?: string;
    label: string;
    active?: boolean;
    iconName: ComponentProps<typeof Icon>['name'];
    onSelect: () => void;
    rightSlot?: ReactNode;
};
export const PaymentOption: FC<Props> = ({
    className,
    iconName,
    label,
    active,
    onSelect,
    rightSlot,
}) => {
    return (
        <div
            className={classNames(styles.block, className, {
                [styles.active]: active,
            })}
            onClick={onSelect}
        >
            {active && (
                <div className={styles.success}>
                    <Icon name="success" />
                </div>
            )}
            {!active && <Icon className={styles.icon} name={iconName} />}
            <Text.Bold16>{label}</Text.Bold16>
            {rightSlot && <div className={styles.rightSlot}>{rightSlot}</div>}
        </div>
    );
};
